/* eslint-disable max-len */
/* eslint-disable camelcase */
import { isSubscription } from 'app/const/subscription';
import {
    CATEGORIES_URL_VALUES,
} from 'app/const/categories';
import {
    getFullTitle,
    getPurchaseEventParams,
    getEventLabel,
    getFlatCheckoutParam,
    getMobileEventLable,
    prepareLocationName,
} from '../../events.utils';

export const yandexMetrikaSpecificEventsRecord = [
    /**
     * @event 'add_to_cart'
     * @note YM goal should match eventName
     */
    {
        eventName: 'add_to_cart',
        description: 'Событие Добавления блюда в корзину (YM reachGoal)',
        meta: ['state'],
        scope: ['menu', 'basket', 'landing'],
        check() {
            return true;
        },
        prepare(data) {
            const dishes = Array.isArray(data.dishes) ? data.dishes : [];
            const firstDish = dishes[0] || {};

            const dishIds = dishes.map((d) => d?.id).filter(Boolean);
            const dishNames = dishes.map((d) => d?.title || d?.caption).filter(Boolean);

            const portion = Number(firstDish?.portion || firstDish?.portions || 1) || 1;
            const price = Number(firstDish?.price || 0) || 0;
            const value = price * portion;

            return {
                event: 'reachGoal',
                goal: data.eventName,
                // YM goal params (will show in "params" for goal achievement)
                source_name: data.source,
                typeOfSet: data.typeOfSet,
                subscriptionType: data.subscriptionType,

                dish_id: firstDish?.id,
                dish_title: firstDish?.title,
                dish_caption: firstDish?.caption,
                dish_category_id: firstDish?.categoryId,
                dish_price: price,
                dish_portion: portion,
                value,

                dish_ids: dishIds.join(','),
                dish_names: dishNames.join(','),
            };
        },
    },
    /**
     * @event 'setUserId'
     * @note YM goal should match eventName
     */
    {
        eventName: 'setUserId',
        description: 'Установка userId в Яндекс.Метрике',
        meta: ['state'],
        scope: ['menu', 'landing'],
        check() {
            return true;
        },
        prepare(data) {
            const { userId } = data;

            return {
                event: 'userParams',
                goal: data.eventName,

                user_id: userId,
                account_id: userId,
                UserID: userId,
            };
        },
    },
    /**
     * @event 'Burger_Menu_Open'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Burger_Menu_Open',
        description: 'Событие открытия бургер-меню в мобильной версии (YM reachGoal)',
        meta: ['click'],
        scope: ['index', 'menu'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Burger_Menu_Close'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Burger_Menu_Close',
        description: 'Событие закрытия бургер-меню в мобильной версии (YM reachGoal)',
        meta: ['click'],
        scope: ['index', 'landing', 'spa'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Burger_Menu_Click'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Burger_Menu_Click',
        description: 'Клик по ссылкам внутри бургер-меню (YM reachGoal)',
        meta: ['click'],
        scope: ['index', 'menu'],
        check(data) {
            return Boolean(data.button_name);
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Header_Click'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Header_Click',
        description: "Клик по ссылкам и кнопкам в header'e (YM reachGoal)",
        meta: ['click'],
        scope: ['landing', 'menu', '5x2'],
        check() {
            return true;
        },
        prepare(data) {
            const { button_name } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                button_name,
                source_name: window.location.pathname,
            };
        },
    },
    /**
     * @event 'Menu_Side'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Menu_Side',
        description: 'Клик по пунктам мобильного навигационного меню (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { text } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                event_params: text,
            };
        },
    },
    /**
     * @event 'Lead_Sent'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Lead_Sent',
        description: 'Отправка лида (YM reachGoal)',
        meta: ['state'],
        scope: ['landing', 'menu', '5x2'],
        check() {
            return true;
        },
        prepare(data) {
            const {
                phone, email, isNewbie, lead_type, id,
            } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                phone: phone?.length >= 11 ? phone : null,
                email,
                source_name: prepareLocationName(),
                lead_id: id,
                lead_type,
                user_type: isNewbie ? 'new' : 'old',
            };
        },
    },
    /**
     * @event 'Lead_Sent_First'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Lead_Sent_First',
        description: 'Отправка первого лида для пользователя (YM reachGoal)',
        meta: ['state'],
        scope: ['landing', 'menu', '5x2'],
        check() {
            return true;
        },
        prepare(data) {
            const {
                phone, email, isNewbie, lead_type, id,
            } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                phone,
                email,
                source_name: prepareLocationName(),
                lead_id: id,
                lead_type,
                user_type: isNewbie ? 'new' : 'old',
            };
        },
    },
    /**
     * @event 'Submit_Phone_Number'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Submit_Phone_Number',
        description: 'Заполнение номера телефона в форме (YM reachGoal)',
        meta: ['submit'],
        scope: ['5x2', 'auth', 'checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const { source, userType } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                source_name: source,
                user_type: userType,
            };
        },
    },
    /**
     * @event 'Track_Login'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Track_Login',
        description: 'Успешный логин пользователя (YM reachGoal)',
        meta: ['state'],
        scope: ['menu', 'landing'],
        check() {
            return true;
        },
        prepare(data) {
            const { isFirstAuth } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                first_auth: isFirstAuth,
            };
        },
    },
    /**
     * @event 'Collection_Click'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Collection_Click',
        description: 'Клик по баннерам с подборками (YM reachGoal)',
        meta: ['click'],
        scope: ['menu', 'main'],
        check() {
            return true;
        },
        prepare(data) {
            const { banner_name, source_name } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                banner_name,
                source_name,
            };
        },
    },
    /**
     * @event 'Product_Impression'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Product_Impression',
        description: 'Блюдо попало во вьюпорт (YM reachGoal)',
        meta: ['viewport'],
        scope: ['menu', 'basket'],
        check() {
            return true;
        },
        prepare(data) {
            const {
                dish, dishIndex, subscriptionType, source_name, isMaxiBlock,
            } = data;
            const eventDish = dish[0] || {};

            const price = isSubscription(subscriptionType) ? Math.ceil(eventDish.price * 0.9) : eventDish.price;

            return {
                event: 'reachGoal',
                goal: data.eventName,
                dish_name: getFullTitle(eventDish),
                dish_id: eventDish.id,
                dish_index: dishIndex,
                price,
                category: CATEGORIES_URL_VALUES[eventDish.categoryId] || eventDish.categoryId,
                source_name,
                isMaxiBlock,
            };
        },
    },
    /**
     * @event 'Track_Click_Best_Set'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Track_Click_Best_Set',
        description: "Клик по кнопке с подборками в header'e spa (YM reachGoal)",
        meta: ['state'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { setName } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                banner_name: setName,
            };
        },
    },
    /**
     * @event 'Change_Category'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Change_Category',
        description: "Смена категории из header'a (YM reachGoal)",
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { categoryId } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                event_params: CATEGORIES_URL_VALUES[categoryId],
            };
        },
    },
    /**
     * @event 'Categories_In_Viewport'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Categories_In_Viewport',
        description: 'Категория попала во вьюпорт (YM reachGoal)',
        meta: ['viewport'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { categoryId, scrollName = null } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                event_params: categoryId ? CATEGORIES_URL_VALUES[categoryId] : scrollName,
            };
        },
    },
    /**
     * @event 'Change_Filter_Item'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Change_Filter_Item',
        description: 'Включение/выключение фильтров (YM reachGoal)',
        meta: ['state'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const eventLabel = getEventLabel(data) || {};
            const { event, eventName, ...params } = eventLabel;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'track_Filtration_Steps'
     * @note YM goal should match eventName
     */
    {
        eventName: 'track_Filtration_Steps',
        description: 'Подтверждение применения фильтров (YM reachGoal)',
        meta: ['submit'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { steps } = data;
            const eventLabel = steps.map((step) => `${step.itemKey}-${step.action}-${step.tagTitle}`).join(';');
            return {
                event: 'reachGoal',
                goal: data.eventName,
                event_label: eventLabel,
            };
        },
    },
    /**
     * @event 'Observe_Tags_In_Viewport'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Observe_Tags_In_Viewport',
        description: 'Теги фильтров попали во вьюпорт (YM reachGoal)',
        meta: ['viewport'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { nextResult } = data;
            const [eventparams] = nextResult;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                event_params: eventparams,
            };
        },
    },
    /**
     * @event 'Dish_Details_Viewed'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Dish_Details_Viewed',
        description: 'Открытие модального окна с информацией о блюде (YM reachGoal)',
        meta: ['click'],
        scope: ['menu', 'landing'],
        check() {
            return true;
        },
        prepare(data) {
            const dish = data;
            const { source, subscriptionType } = dish;
            const price = isSubscription(subscriptionType) ? Math.ceil(dish.price * 0.9) : dish.price;

            return {
                event: 'reachGoal',
                goal: data.eventName,
                dish_id: dish.id,
                dish_name: getFullTitle(dish),
                dish_category: CATEGORIES_URL_VALUES[dish.categoryId] || dish.categoryId,
                price,
                source_name: source,
            };
        },
    },
    /**
     * @event 'Track_Card_Click'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Track_Card_Click',
        description: 'Клик по карточке блюда (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { list, subscriptionType, index } = data;
            const price = isSubscription(subscriptionType) ? Math.ceil(data.price * 0.9) : data.price;

            return {
                event: 'reachGoal',
                goal: data.eventName,
                dish_id: data.id,
                dish_name: getFullTitle(data),
                price,
                category: CATEGORIES_URL_VALUES[data.categoryId] || data.categoryId,
                list,
                position: Number(index) + 1,
            };
        },
    },
    /**
     * @event 'Filter_Open_Category'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Filter_Open_Category',
        description: 'Открытие списка категорий (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Filter_Change_Filters'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Filter_Change_Filters',
        description: 'Изменение фильтров (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { filterValue } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                filter_value: filterValue,
            };
        },
    },
    /**
     * @event 'Filter_Change_Tags'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Filter_Change_Tags',
        description: 'Выбор фильтра в пилюльке (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { filterValue } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                filter_value: filterValue,
            };
        },
    },
    /**
     * @event 'Filter_Change_Category'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Filter_Change_Category',
        description: 'Изменение категории в фильтрах (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const {
                name, eventName, filterValue, ...params
            } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                filter_value: filterValue,
                ...params,
            };
        },
    },
    /**
     * @event 'Filter_Open_City'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Filter_Open_City',
        description: 'Открытие выбора города (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Filter_Change_City'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Filter_Change_City',
        description: 'Изменение города в фильтрах (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Filter_Open_Week'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Filter_Open_Week',
        description: 'Открытие выбора недели (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Filter_Change_Week'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Filter_Change_Week',
        description: 'Изменение недели в фильтрах (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            const paramsToSend = getMobileEventLable(data) || {};

            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
                filter_value: paramsToSend.eventParams,
                event_params: paramsToSend.eventParams,
            };
        },
    },
    /**
     * @event 'Go_to_Cart'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Go_to_Cart',
        description: 'Переход в корзину (YM reachGoal)',
        meta: ['click'],
        scope: ['menu', 'basket'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Custom_Card_Click'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Custom_Card_Click',
        description: 'Клик по карточке кастомизации блюда (YM reachGoal)',
        meta: ['click'],
        scope: ['menu', 'basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Custom_Card_Close'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Custom_Card_Close',
        description: 'Закрытие карточки кастомизации блюда (YM reachGoal)',
        meta: ['click'],
        scope: ['menu', 'basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Custom_Card_Close_Confirmation'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Custom_Card_Close_Confirmation',
        description: 'Закрытие карточки кастомизации с подтверждением (YM reachGoal)',
        meta: ['click'],
        scope: ['menu', 'basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Custom_Card_Open'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Custom_Card_Open',
        description: 'Открытие карточки кастомизации блюда (YM reachGoal)',
        meta: ['click'],
        scope: ['menu', 'basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Custom_Card_Change'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Custom_Card_Change',
        description: 'Изменение кастомизации блюда (YM reachGoal)',
        meta: ['click'],
        scope: ['menu', 'basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Custom_Card_Dish_decrease_quantity'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Custom_Card_Dish_decrease_quantity',
        description: 'Уменьшение количества блюда (YM reachGoal)',
        meta: ['click'],
        scope: ['basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Custom_Card_Dish_increase_quantity'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Custom_Card_Dish_increase_quantity',
        description: 'Увеличение количества блюда (YM reachGoal)',
        meta: ['click'],
        scope: ['basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Custom_Tag_Toggle'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Custom_Tag_Toggle',
        description: 'Клик по тегам кастомизации (YM reachGoal)',
        meta: ['click'],
        scope: ['basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { tagName, sourceName, state } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                tag_name: tagName,
                source_name: sourceName,
                state,
            };
        },
    },
    /**
     * @event 'Custom_Apply'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Custom_Apply',
        description: 'Сабмит тегов кастомизации (YM reachGoal)',
        meta: ['click'],
        scope: ['basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { sourceName } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                source_name: sourceName,
            };
        },
    },
    /**
     * @event 'Open_Pop_Over'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Open_Pop_Over',
        description: 'Открытие детаклы с описанием блюда из A/B/C теста (YM reachGoal)',
        meta: ['click'],
        scope: ['basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { eventLabel } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                event_label: eventLabel,
            };
        },
    },
    /**
     * @event 'Change_dish_Basket'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Change_dish_Basket',
        description: 'Клик по кнопке "Заменить блюдо" (YM reachGoal)',
        meta: ['click'],
        scope: ['basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { dish_id, dish_name } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                dish_id,
                dish_name,
            };
        },
    },
    /**
     * @event 'Custom_Card_Dish_Delete'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Custom_Card_Dish_Delete',
        description: 'Удаление блюда при замене на другое (YM reachGoal)',
        meta: ['click'],
        scope: ['basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { dish_id, source } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                dish_id,
                source_name: source,
            };
        },
    },
    /**
     * @event 'Click_open_popup_upsell_check_mark'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Click_open_popup_upsell_check_mark',
        description: 'Открытие поп-апа в AdditionalDish (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const { dish_id, dish_name } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                dish_id,
                dish_name,
            };
        },
    },
    /**
     * @event 'Upsell_Click'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Upsell_Click',
        description: 'Клик по апселлу в корзине (YM reachGoal)',
        meta: ['click'],
        scope: ['basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { name, eventName, ...params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Check_Send_Promo'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Check_Send_Promo',
        description: 'Проверка валидности промокода (YM reachGoal)',
        meta: ['submit'],
        scope: ['5x2', 'basket', 'checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const {
                isPromoCodeExists,
                isPromocodeCombineWithDiscount,
                isSubscriptionActivated,
                promocodeStatus,
                promo,
                sourceName,
            } = data;

            const isRecurrentBlockPromo = !isSubscriptionActivated || isPromocodeCombineWithDiscount;
            const isPromoEntirelyExists = isPromoCodeExists && isRecurrentBlockPromo;
            const result = isPromoEntirelyExists && promocodeStatus === 'active' ? 'success' : 'failure';

            return {
                event: 'reachGoal',
                goal: data.eventName,
                promo,
                result,
                source_name: sourceName,
            };
        },
    },
    /**
     * @event 'Check_Info_About_Delivery'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Check_Info_About_Delivery',
        description: 'Открытие модального окна с информацией о доставке (YM reachGoal)',
        meta: ['click'],
        scope: ['basket', 'checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Check_Info_About_Subscription'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Check_Info_About_Subscription',
        description: 'Открытие модального окна с информацией о подписке (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout', 'basket'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Click_Address'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Click_Address',
        description: "Клик по input'у ввода адреса доставки (YM reachGoal)",
        meta: ['click'],
        scope: ['basket', 'landing', 'checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const { eventLocation } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                source_name: eventLocation,
            };
        },
    },
    /**
     * @event 'Checkout_Close_Address_Popup'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Close_Address_Popup',
        description: 'Закрытие окна ввода адреса (YM reachGoal)',
        meta: ['click'],
        scope: ['landing', 'basket'],
        check() {
            return true;
        },
        prepare(data) {
            const { eventLocation, result } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                source_name: eventLocation,
                result,
            };
        },
    },
    /**
     * @event 'Check_Subscription_Toggle'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Check_Subscription_Toggle',
        description: 'Переключение подписки (YM reachGoal)',
        meta: ['click'],
        scope: ['basket', 'checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const { eventValue } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                event_value: eventValue,
            };
        },
    },
    /**
     * @event 'Form_Wish'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Form_Wish',
        description: 'Отправка формы с комментарием кастомизации (YM reachGoal)',
        meta: ['submit'],
        scope: ['basket', 'checkout', 'profile'],
        check() {
            return true;
        },
        prepare(data) {
            const { eventLocation } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                source_name: eventLocation,
            };
        },
    },
    /**
     * @event 'Checkout_Start_Onepager'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Start_Onepager',
        description: 'Открытие формы пошагового чекаута (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Start_Phone'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Start_Phone',
        description: 'Открытие формы ввода телефона (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Start_Code'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Start_Code',
        description: 'Открытие формы ввода пинкода (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Start_Address'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Start_Address',
        description: 'Открытие формы ввода адреса (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Start_Date'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Start_Date',
        description: 'Открытие формы ввода даты доставки (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Start_Confirmation'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Start_Confirmation',
        description: 'Открытие форм выбора оплаты и промокода (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Close_Phone'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Close_Phone',
        description: 'Закрытие формы ввода телефона (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Close_Code'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Close_Code',
        description: 'Закрытие формы ввода пинкода (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Close_Address'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Close_Address',
        description: 'Закрытие формы ввода адреса (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Close_Date'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Close_Date',
        description: 'Закрытие формы выбора даты доставки (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Close_Confirmation'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Close_Confirmation',
        description: 'Закрытие форм выбора оплаты и промокода (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Stepback_Address'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Stepback_Address',
        description: 'Возврат из экрана выбора адреса доставки (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Stepback_Date'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Stepback_Date',
        description: 'Возврат из экрана выбора даты доставки (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Stepback_Confirmation'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Stepback_Confirmation',
        description: 'Возврат из экрана выбора способа оплаты (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Submit_Validation_Code'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Submit_Validation_Code',
        description: 'Результат введенного пинкода (YM reachGoal)',
        meta: ['submit'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const { result } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                result,
            };
        },
    },
    /**
     * @event 'Checkout_Click_Date'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Click_Date',
        description: 'Клик по кнопке выбора даты доставки (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Click_Time'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Click_Time',
        description: 'Клик по кнопке выбора времени доставки (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Back_From_Editing_Phone'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Back_From_Editing_Phone',
        description: 'Возвращение к чекауту с шага телефона (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Back_From_Editing_Address'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Back_From_Editing_Address',
        description: 'Возвращение к чекауту с шага адреса (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Back_From_Editing_Date'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Back_From_Editing_Date',
        description: 'Возвращение к чекауту с шага даты и времени (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Back_From_Editing_Confirmation'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Back_From_Editing_Confirmation',
        description: 'Возвращение к чекауту с шага способа оплаты (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Click_Address_Comment'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Click_Address_Comment',
        description: "Клик по input'у комментария (YM reachGoal)",
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Payment_Radiobuttons'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Payment_Radiobuttons',
        description: 'Клик по радиокнопке выбора способа оплаты (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const { button_name } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                button_name,
            };
        },
    },
    /**
     * @event 'Payment_Button_Click'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Payment_Button_Click',
        description: "Клик по кнопке 'перейти к оплате' (YM reachGoal)",
        meta: ['click'],
        scope: ['menu', 'checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Payment_Button_Click_Error'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Payment_Button_Click_Error',
        description: "Ошибка при клике по кнопке 'оплаты' (YM reachGoal)",
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Close_Onepager'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Close_Onepager',
        description: 'Закрытие чекаута (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Popup_Menu_Will_Change'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Popup_Menu_Will_Change',
        description: 'Показ всплывающего окна "Будет новое меню" (YM reachGoal)',
        meta: ['mount'],
        scope: ['checkout', 'spa'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Click_Popup_Menu_Will_Change'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Click_Popup_Menu_Will_Change',
        description: 'Клик на всплывающее окно "Будет новое меню" (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout', 'spa'],
        check() {
            return true;
        },
        prepare(data) {
            const { eventAction } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                event_action: eventAction,
            };
        },
    },
    /**
     * @event 'Checkout_Close_Popup_Menu_Will_Change'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Close_Popup_Menu_Will_Change',
        description: 'Закрытие окна "Будет новое меню" (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout', 'spa'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'LK_Banner_Click'
     * @note YM goal should match eventName
     */
    {
        eventName: 'LK_Banner_Click',
        description: 'ЛК - клик на баннер НГ (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout', 'spa'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
                banner_name: 'ny',
            };
        },
    },
    /**
     * @event 'Checkout_Select_Printed_Recipes'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Select_Printed_Recipes',
        description: 'Включение свитча "Хочу получать печатные рецепты" (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Checkout_Unselect_Printed_Recipes'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Unselect_Printed_Recipes',
        description: 'Снятие свитча "Хочу получать печатные рецепты" (YM reachGoal)',
        meta: ['click'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Track_Navigate'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Track_Navigate',
        description: 'Шаги оформления заказа: 1 - корзина, 2 - чекаут, 3 - телефон, 4 - все поля (YM reachGoal)',
        meta: ['state'],
        scope: ['basket', 'checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const { step, typeOfSet, sections } = data;

            let dishIds = [];
            if (Array.isArray(sections)) {
                const { ecommerce } = getFlatCheckoutParam(data);
                dishIds = (ecommerce?.checkout?.products || [])
                    .map((product) => product.id)
                    .filter(Boolean);
            }

            return {
                event: 'reachGoal',
                goal: data.eventName,
                step,
                typeOrder: typeOfSet,
                dish_count: dishIds.length,
                dish_ids: dishIds.join(','),
            };
        },
    },
    /**
     * @event 'Invoice_Created'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Invoice_Created',
        description: 'Создание инвойса (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const { invoiceId } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                invoice_id: invoiceId,
            };
        },
    },
    /**
     * @event 'Track_Checkout_User_TYP'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Track_Checkout_User_TYP',
        description: 'Тип пользователя на чекауте (TYP) (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const { userType } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                user_type: userType,
            };
        },
    },
    /**
     * @event 'Checkout_Sent'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_Sent',
        description: 'Отправка формы заказа (переход к оплате) (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const {
                invoiceData, dishes, typeOfSet, external_subscription_id, user_id, user,
            } = data;
            const { ecommerce: { purchase }, userType } = getPurchaseEventParams(invoiceData, dishes);
            const dishNames = (dishes || []).map((dish) => getFullTitle(dish)).join(', ');

            return {
                event: 'reachGoal',
                goal: data.eventName,
                transaction_id: purchase.transaction_id,
                revenue: purchase.revenue,
                shipping: purchase.shipping,
                coupon: purchase.coupon,
                currency: purchase.currency,
                dish_count: (dishes || []).length,
                dish_names: dishNames,
                user_type: userType,
                typeOrder: typeOfSet,
                external_subscription_id,
                user_id: user_id || user,
            };
        },
    },
    /**
     * @event 'Track_Purchase'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Track_Purchase',
        description: 'Успешный заказ (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const {
                invoiceData, dishes, typeOfSet, external_subscription_id, user_id, user,
            } = data;
            const { ecommerce: { purchase }, userType } = getPurchaseEventParams(invoiceData, dishes);
            const dishNames = (dishes || []).map((dish) => getFullTitle(dish)).join(', ');

            return {
                event: 'reachGoal',
                goal: data.eventName,
                transaction_id: purchase.transaction_id,
                revenue: purchase.revenue,
                shipping: purchase.shipping,
                coupon: purchase.coupon,
                currency: purchase.currency,
                dish_count: (dishes || []).length,
                dish_names: dishNames,
                user_type: userType,
                typeOrder: typeOfSet,
                external_subscription_id,
                user_id: user_id || user,
            };
        },
    },
    /**
     * @event 'Go_to_Checkout'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Go_to_Checkout',
        description: 'Переход к оформлению заказа (YM reachGoal)',
        meta: ['click'],
        scope: ['basket', 'checkout'],
        check() {
            return true;
        },
        prepare(data) {
            return {
                event: 'reachGoal',
                goal: data.eventName,
            };
        },
    },
    /**
     * @event 'Pageview'
     * @note YM отправляется как hit (просмотр страницы)
     */
    {
        eventName: 'Pageview',
        description: 'Отслеживание просмотра страницы (YM hit)',
        meta: ['state'],
        scope: ['menu', 'index'],
        check() {
            return true;
        },
        prepare(data) {
            const { pagePath, pageUrl } = data;
            return {
                event: 'hit',
                url: pageUrl,
                title: typeof document !== 'undefined' ? document.title : undefined,
                page_path: pagePath,
            };
        },
    },
    /**
     * @event 'Click_To_Checkout_Button'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Click_To_Checkout_Button',
        description: 'Инициация оформления заказа (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const { price, dishes } = data;
            const dishList = Array.isArray(dishes) ? dishes : [];

            return {
                event: 'reachGoal',
                goal: data.eventName,
                price,
                dish_count: dishList.length,
                dish_ids: dishList.map((dish) => dish.id).filter(Boolean).join(','),
            };
        },
    },
    /**
     * @event 'PaymentButtonClickHandled'
     * @note YM goal should match eventName
     */
    {
        eventName: 'PaymentButtonClickHandled',
        description: 'Обработка клика по кнопке оплаты (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check() {
            return true;
        },
        prepare(data) {
            const { label } = data;
            return {
                event: 'reachGoal',
                goal: data.eventName,
                label,
            };
        },
    },
    /**
     * @event 'Checkout_First_Payment'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Checkout_First_Payment',
        description: 'Первый платеж нового пользователя (YM reachGoal)',
        meta: ['state'],
        scope: ['checkout'],
        check(data) {
            const userType = data.userType || data.invoiceData?.userType;
            return userType === 'new';
        },
        prepare(data) {
            const {
                invoiceData, dishes, typeOfSet,
                external_subscription_id, user_id, user, userType,
            } = data;

            let purchaseParams = {};
            let user_type = userType;
            if (invoiceData && Array.isArray(dishes)) {
                const { ecommerce: { purchase }, userType: purchaseUserType } = getPurchaseEventParams(invoiceData, dishes);
                purchaseParams = {
                    transaction_id: purchase.transaction_id,
                    revenue: purchase.revenue,
                    shipping: purchase.shipping,
                    coupon: purchase.coupon,
                    currency: purchase.currency,
                };
                user_type = purchaseUserType;
            }

            return {
                event: 'reachGoal',
                goal: data.eventName,
                ...purchaseParams,
                user_type,
                typeOrder: typeOfSet,
                external_subscription_id,
                user_id: user_id || user,
            };
        },
    },
    /**
     * @event 'Click_Select_HLS'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Click_Select_HLS',
        description: 'Выбор green (HLS) версии блюда в новом меню (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName, params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Click_Unselect_HLS'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Click_Unselect_HLS',
        description: 'Выбор обычной версии блюда в новом меню (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName, params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Click_explanation'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Click_explanation',
        description: 'Клик по объяснению блюда в новом меню (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName, params } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                ...params,
            };
        },
    },
    /**
     * @event 'Click_All_Options'
     * @note YM goal should match eventName
     */
    {
        eventName: 'Click_All_Options',
        description: 'Клик "показать все варианты" в новом меню (YM reachGoal)',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName, value } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
                value,
            };
        },
    },
    /**
     * @event 'open_upsell_screen'
     * @note YM goal should match eventName
     */
    {
        eventName: 'open_upsell_screen',
        description: 'Поднятие дополнительного экрана на /upsell',
        meta: ['click'],
        scope: ['menu'],
        check() {
            return true;
        },
        prepare(data) {
            const { eventName } = data;
            return {
                event: 'reachGoal',
                goal: eventName,
            };
        },
    },
];

